"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fosciandora": {
    "a65958a0": [{
      "hkey": "d1e9067d",
      "slug": "fosciandora",
      "name": "Fosciandora",
      "primary": true,
      "skipSearch": false
    }],
    "la-villa": [{
      "hkey": "d1e9067d",
      "slug": "fosciandora",
      "name": "Fosciandora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "84e22d07": [{
      "hkey": "d1e9067d",
      "slug": "fosciandora",
      "name": "Fosciandora",
      "primary": true,
      "skipSearch": false
    }],
    "migliano": [{
      "hkey": "d1e9067d",
      "slug": "fosciandora",
      "name": "Fosciandora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;